export default __webpack_public_path__ + "static/docker-fceb0b862e53e97f0415d764d4747b5c.png";